// eslint-disable-next-line import/prefer-default-export
export var DEFAULT_EMPTY_MESSAGE = "No items to display";